import React from 'react';
import AuthService from './authService.js';
import rules from '../rbac-rules';
import regexHelper from '../Helpers/regexHelper.js';
import ErrorMessage from '../Elements/ErrorMessage.js';

class RoleService extends React.Component
{
  // Type, item and action are defined in rbac-rules.js
  // type ie.: 'function' or 'menu'
  // item ie.: 'administration'
  // action ie.: 'visit' or 'write'
  static CheckUserPermission (type, item, roleFunctionParameter)
  {
    // console.log('RoleService.CheckUserPermission', type, item, roleFunctionParameter);
    let hasPermission = false;
    const authservice = AuthService.getInstance();
    const loggedInUser = authservice.GetLoggedInUser();

    if (loggedInUser === undefined) return false;
    const userRoles = [ 'User' ].concat(loggedInUser.roles);

    // Comment out the following if block to simulate "User" role.
    if (item !== 'god' && (userRoles.includes('Admin') || userRoles.includes('Developer')))
    {
      return true;
    }

    const currentRules = rules;

    currentRules.forEach((rule) =>
    {
      userRoles.forEach((role) =>
      {
        try
        {
          if (
            typeof rule.role !== 'function' &&
            // rule.rule.toLocaleLowerCase() === "allow" &&
            // rule.action.toLocaleLowerCase() === action.toLocaleLowerCase() &&
            rule.role
              .toLowerCase()
              .split(',')
              .findIndex((x) => regexHelper.matchWildcard(role.toLowerCase(), x)) !== -1 &&
            rule.type.toLowerCase().split(',').includes(type.toLowerCase()) &&
            rule.item.toLowerCase() === item.toLowerCase()
          )
          {
            hasPermission = true;
          }
        } catch (e)
        {
          ErrorMessage.LogDevInfo('Error checking role permission:', e);
          throw e;
        }
      });
    });

    // If the rule is a function, we need to call it with the roleFunctionParameter
    currentRules.forEach((rule) =>
    {
      if (typeof rule.role === 'function' && rule.type === type && rule.item === item)
      {
        hasPermission = rule.role(roleFunctionParameter);
      }
    });

    return hasPermission;
  }
}

export default RoleService;
